import { getFirms, removeFirm } from "../../utils/api";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { SET_PORTAL_API, RESET_PORTAL } from "./portal_actions";
import { TITLE_ERROR } from "../../utils/constants";

export const REQUEST_GET_FIRMS = 'REQUEST_GET_FIRMS';
export const REQUEST_GET_FIRMS_SUCCESS = 'REQUEST_GET_FIRMS_SUCCESS';
export const REQUEST_GET_FIRMS_FAILED = 'REQUEST_GET_FIRMS_FAILED';

export const REQUEST_REMOVE_FIRM_SUCCESS = 'REQUEST_REMOVE_FIRM_SUCCESS';
export const REQUEST_REMOVE_FIRM_FAILED = 'REQUEST_REMOVE_FIRM_FAILED';

export const RESET_FIRMS = 'RESET_FIRMS';


export const getFirmsThunk = (accessToken, refreshToken, user_id) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    getFirms(accessToken, refreshToken, user_id)
      .then(data => {
        dispatch({
          type: REQUEST_GET_FIRMS_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_GET_FIRMS_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}


export const removeFirmThunk = (accessToken, refreshToken, inn, user_id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING });
    removeFirm(accessToken, refreshToken, inn, user_id)
      .then(data => {
        dispatch({
          type: REQUEST_REMOVE_FIRM_SUCCESS,
          payload: data
        });
        dispatch({ type: RESET_PORTAL });
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({ type: REQUEST_REMOVE_FIRM_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
        // dispatch({ type: RESET_PORTAL });
      });
  }
}
